import { findStackTraceEntryByPreviousFile } from '@philips-internal/oswald-common-utils';
function findStackTraceEntryOfDecorator() {
    return findStackTraceEntryByPreviousFile('/utils/meta-validator.js');
}
export { findStackTraceEntryOfDecorator, };
//# sourceMappingURL=stack-trace.js.map